
import { Action, State, Getter } from 'vuex-class';

import { Component, Vue, Watch } from 'vue-property-decorator';

import { PaymentApiAxiosParamCreator, PayrollEmployeeH3 } from '@/api/openapi';
import Pagination from '@/components/Pagination.vue';
import { paginationMixin, parsePagination, paginationPersistenceMixin } from '@/utils';
import PayrollEmployeeFilters from './PayrollEmployeeFilters.vue';

type Search = {
  placementGroup: string | null;
  period: string | null;
  periodPart: string | null;
  workplace: string | null;
  workplaceType: string | null;
};

// @ts-ignore
@Component({
  components: {
    PayrollEmployeeFilters,
    Pagination,
  },
  mixins: [paginationMixin, paginationPersistenceMixin],
})
export default class PayrollEmployees extends Vue {
  @Action displayError!: (s: string) => void;
  @Action displaySuccess!: (s: string) => void;
  @State loggedInUser: any;
  @Getter loggedInUserHasAnyPermission: any;

  // Declare mixin properties and methods for TypeScript
  currentPage!: number;
  currentLimit!: number;
  loadPaginationOptions!: () => void;
  savePaginationOptions!: () => void;
  changePageWithPersistence!: (page: number) => void;
  changeLimitWithPersistence!: (limit: number) => void;
  getGlobalIndex!: (localIndex: number, pagination: any) => number;

  // Set the pagination key
  paginationKey = 'payrollEmployeesH3';

  search: Search = {
    placementGroup: null,
    period: null,
    periodPart: null,
    workplace: null,
    workplaceType: null,
  };

  loading = true;
  error = false;
  data: Array<PayrollEmployeeH3> | null = null;
  pagination: any = null;

  async loadData(page = 1, limit = 100) {
    this.loading = true;
    this.data = null;
    this.error = false;
    try {
      const response = await this.$paymentApi.payrollemployeeh3excelList({
        period: this.search.period ? this.search.period : undefined,
        periodPart: this.search.periodPart ? this.search.periodPart : undefined,
        placementGroup: this.search.placementGroup ? this.search.placementGroup : undefined,
        workplace: this.search.workplace ? this.search.workplace : undefined,
        workplaceType: this.search.workplaceType ? this.search.workplaceType : undefined,
        page,
        limit,
      });

      this.data = response.data;
      this.pagination = parsePagination(response);
    } catch (e) {
      this.error = true;
      this.displayError(`Óvænt villa kom upp. Vinsamlegast reyndu aftur.`);
    } finally {
      this.loading = false;
    }
  }

  @Watch('search', { deep: true })
  onSearchChanged() {
    this.loadData(this.currentPage, this.currentLimit);
  }

  async excel() {
    const xlsx = await PaymentApiAxiosParamCreator()
      .payrollemployeeh3Excel(
        this.search.period ? this.search.period : undefined,
        this.search.periodPart ? this.search.periodPart : undefined,
        this.search.placementGroup ? this.search.placementGroup : undefined,
        this.search.workplace ? this.search.workplace : undefined,
        this.search.workplaceType ? this.search.workplaceType : undefined,
      )
      .catch(e => {
        this.$log.error(e);
      });
    if (!xlsx) {
      this.displayError(`Óvænt villa kom upp. Vinsamlegast reyndu aftur.`);
      return;
    }
    window.location.href = xlsx.url;
  }

  created() {
    this.loadPaginationOptions();
    this.loadData(this.currentPage, this.currentLimit);
  }
}
